import styles from './resources.module.scss';
import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import PageTitle from '../../page-title/page-title';
import { Box, Container, Tab, Tabs } from '@frontend-workspace/react-shared-lib';

import Place from './place/place';
import Instructor from './instructor/instructor';
import ComputerEquipment from './computer-equipment/computer-equipment';
import Duration from './duration/duration';
import Prices from './prices/prices';
import Level from './level/level';
import Category from './category/category';
import Pictures from './pictures/pictures';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ResourcesProps { }

export function Resources(props: ResourcesProps) {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const navigateToTabOne = () => setSelectedTab(0);
  const navigateToTabTwo = () => setSelectedTab(1);
  const navigateToTabThree = () => setSelectedTab(2);
  const navigateToTabFour = () => setSelectedTab(3);
  const navigateToTabFive = () => setSelectedTab(4);
  const navigateToTabSix = () => setSelectedTab(5);
  const navigateToTabSeven = () => setSelectedTab(6);
  const navigateToTabEight = () => setSelectedTab(7);

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t('app.resources')} subtitle={`(${t("standard.admin")})`} />
            <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '20px' }}>
              <Tabs
                value={selectedTab}
                variant="scrollable"
                scrollButtons="auto">
                <Tab label={t('standard.place')} onClick={navigateToTabOne} />
                <Tab label={t('standard.instructor')} onClick={navigateToTabTwo} />
                <Tab label={t('standard.computerEquipment')} onClick={navigateToTabThree} />
                <Tab label={t('standard.duration')} onClick={navigateToTabFour} />
                <Tab label={t('standard.prices')} onClick={navigateToTabFive} />
                <Tab label={t('standard.level')} onClick={navigateToTabSix} />
                <Tab label={t('standard.category')} onClick={navigateToTabSeven} />
                <Tab label={t('standard.pictures')} onClick={navigateToTabEight} />
              </Tabs>
            </Box>
            <div>
              {selectedTab === 0 && <Place />}
              {selectedTab === 1 && <Instructor />}
              {selectedTab === 2 && <ComputerEquipment />}
              {selectedTab === 3 && <Duration />}
              {selectedTab === 4 && <Prices />}
              {selectedTab === 5 && <Level />}
              {selectedTab === 6 && <Category />}
              {selectedTab === 7 && <Pictures />}
            </div>
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default Resources;
